<ng-container *ngIf="addOrderToRemoteCart$ | async"></ng-container>
<ng-container *ngIf="groupMaterialDiscount$ | async"></ng-container>
<ng-container *ngIf="materialGroups$ | async"></ng-container>
<ng-container *ngIf="operationGroups$ | async"></ng-container>
<ng-container *ngIf="saveDeliveryAddress$ | async"></ng-container>
<ng-container *ngIf="markQuestionsAsRead$ | async"></ng-container>
<ng-container *ngIf="cuttingEnd$ | async"></ng-container>
<ng-container *ngIf="order$ | async"></ng-container>
<ng-container *ngIf="question$ | async"></ng-container>

<div id="product" class="page-layout carded fullwidth tabbed inner-scroll">
  <!-- TOP BACKGROUND -->
  <div class="top-bg accent"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">
    <!-- CONTENT HEADER -->
    <div class="header accent flex flex-row justify-between items-center">
      <!-- APP TITLE -->
      <div [cslOverlayLoader]="loading$" class="flex flex-row justify-start items-center">
        <button class="mr-0 sm:mr-1" mat-icon-button (click)="location.back()">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div
          class="product-image mr-2 sm:mr-1 hidden sm:block"
          *fuseIfOnDom
          [@animate]="{ value: '*', params: { delay: '50ms', scale: '0.2' } }">
          <img [src]="'./assets/images/ecommerce/product-image-placeholder.png'" />
        </div>

        <div
          class="flex flex-col justify-start items-start"
          *fuseIfOnDom
          [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
          <div class="h2" *ngIf="orderId !== 'new'">
            {{ order.name }}
          </div>
          <div i18n class="h2" *ngIf="orderId === 'new'">Новый заказ</div>
          <div class="subtitle secondary-text">
            <span i18n>Карточка заказа</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <ng-container *ngIf="!order.archived && cuttingSettings$ | async">
        <div [ngSwitch]="order.status.action" class="flex flex-row justify-start items-center gap-2">
          <ng-container *ngSwitchCase="thisOrderStatusActions.Create">
            <button
              mat-raised-button
              class="save-product-button mat-white-bg text-uppercase"
              [disabled]="
                !materialsValid || order.cuttingProccess || orderSaving || (!hubConnected && orderId !== 'new')
              "
              (click)="saveOrAddOrder()">
              <span i18n>Сохранить черновик</span>
            </button>

            <button
              mat-raised-button
              class="save-product-button mat-white-bg text-uppercase"
              [disabled]="!materialsValid || order.cuttingProccess || !hubConnected || orderSaving"
              *ngIf="orderId !== 'new' && !isOrderFromOnlyDontCuttedItems()"
              (click)="runCutting()">
              <span i18n>Сохранить и Раскроить</span>
            </button>

            <button
              mat-raised-button
              class="save-product-button mat-white-bg text-uppercase"
              [disabled]="!materialsValid || order.cuttingProccess || orderSaving"
              *ngIf="orderId === 'new' && !isOrderFromOnlyDontCuttedItems()"
              data-testid="saveAndCutButton"
              (click)="runCutting()">
              <span i18n>Сохранить и Раскроить</span>
            </button>

            <button
              *ngIf="isOrderFromOnlyDontCuttedItems()"
              mat-raised-button
              class="save-product-button mat-white-bg text-uppercase"
              (click)="orderingOrder()"
              [disabled]="!materialsValid">
              <span i18n>Оформить</span>
            </button>
          </ng-container>

          <ng-container *ngSwitchCase="thisOrderStatusActions.CuttingCompleted">
            <button
              mat-raised-button
              class="save-product-button mat-white-bg text-uppercase"
              [disabled]="!materialsValid || order.cuttingProccess || !hubConnected || orderSaving"
              *ngIf="orderId !== 'new'"
              (click)="saveOrAddOrder()">
              <span i18n>Сохранить черновик</span>
            </button>

            <button
              mat-raised-button
              class="save-product-button mat-white-bg text-uppercase"
              [disabled]="!materialsValid || order.cuttingProccess || !hubConnected || orderSaving"
              *ngIf="orderId !== 'new'"
              (click)="runCutting()">
              <span i18n>Сохранить и Раскроить</span>
            </button>

            <button
              mat-raised-button
              class="save-product-button mat-white-bg text-uppercase"
              (click)="orderingOrder()"
              [disabled]="!materialsValid">
              <span i18n>Оформить</span>
            </button>
          </ng-container>

          <ng-container *ngSwitchCase="thisOrderStatusActions.Ordering">
            <div class="status-title flex flex-row justify-start items-center gap-2">
              <mat-icon>access_time</mat-icon>

              <p class="mat-title m-0">
                <span *ngIf="order.status.isDefault">{{ order.status.action | defaultCuttingOrderStatusName }}</span>
                <span *ngIf="!order.status.isDefault">{{ order.status.name }}</span>
              </p>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="thisOrderStatusActions.Verified">
            <button mat-raised-button class="save-product-button mat-white-bg text-uppercase" (click)="confirmOrder()">
              <span i18n>Запустить в работу</span>
            </button>
          </ng-container>

          <ng-container *ngSwitchCase="thisOrderStatusActions.Confirm">
            <!-- PAYMING -->
            <div
              class="flex flex-row justify-start items-center gap-3"
              *ngIf="
                hasCustomPayment() ||
                  getAvailabilityPaySystem(1) ||
                  getAvailabilityPaySystem(2) ||
                  getAvailabilityPaySystem(3);
                else noPaymentSysTemplate
              ">
              <div i18n class="mat-title status-title my-0" *ngIf="!hasCustomPayment()">Оплатить заказ:</div>
              <div class="flex flex-row justify-start items-center gap-3">
                <button
                  mat-raised-button
                  class="payment-sys-button mat-white-bg text-uppercase"
                  (click)="addToRemoteCart()"
                  i18n
                  *ngIf="hasCustomPayment()"
                  >Оплатить заказ</button
                >
                <button
                  i18n-matTooltip
                  mat-raised-button
                  class="payment-sys-button mat-white-bg"
                  *ngIf="getAvailabilityPaySystem(1)"
                  matTooltip="Банковской картой">
                  <mat-icon svgIcon="card" (click)="openPSBPayDialog()" class="s-40"> </mat-icon>
                </button>
                <button
                  i18n-matTooltip
                  mat-raised-button
                  class="payment-sys-button mat-white-bg"
                  *ngIf="getAvailabilityPaySystem(2)"
                  matTooltip="Через платежную систему PayPal">
                  <mat-icon svgIcon="paypal" (click)="openPayPalPayDialog()" class="s-40"> </mat-icon>
                </button>
                <button
                  i18n-matTooltip
                  mat-raised-button
                  class="payment-sys-button mat-white-bg"
                  *ngIf="getAvailabilityPaySystem(3)"
                  matTooltip="Через платежную систему Wooppay">
                  <mat-icon svgIcon="wooppay" (click)="openWooppayPayDialog()" class="s-40"> </mat-icon>
                </button>
              </div>
            </div>
            <!-- END PAYMING -->
            <ng-template #noPaymentSysTemplate>
              <p class="mat-title status-title">
                <span *ngIf="order.status.isDefault">{{ order.status.action | defaultCuttingOrderStatusName }}</span>
                <span *ngIf="!order.status.isDefault">{{ order.status.name }}</span>
              </p>
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="thisOrderStatusActions.Completed">
            <p class="mat-title status-title">
              <span *ngIf="order.status.isDefault">{{ order.status.action | defaultCuttingOrderStatusName }}</span>
              <span *ngIf="!order.status.isDefault">{{ order.status.name }}</span>
            </p>
          </ng-container>
        </div>
      </ng-container>

      <div *ngIf="order.archived === true">
        <p i18n class="mat-title status-title">Заказ в архиве</p>
      </div>
    </div>
    <!-- / CONTENT HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card">
      <!-- CONTENT -->
      <div class="content">
        <div [@fadeInOut]="order?.cuttingProccess">
          <div class="cut-progress">
            <p i18n class="h2 text-uppercase">Выполняется раскрой</p>
            <mat-spinner></mat-spinner>
          </div>
        </div>

        <ng-container *ngIf="tariffOptions && order">
          <mat-tab-group
            #tabGroup
            [selectedIndex]="startTabIndex"
            *ngIf="tariffOptions.result && (cuttingSettings$ | async)"
            (selectedTabChange)="selectedTabChange($event.tab)">
            <mat-tab i18n-label label="Общее">
              <div class="tab-content p-6 flex flex-col justify-start items-stretch gap-2" fusePerfectScrollbar>
                <div class="mb-3 flex flex-row justify-start items-start gap-3">
                  <div class="flex flex-col justify-start items-stretch w-1/5">
                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">№ Заказа</div>
                      <div class="flex-1 param-table-value">{{ order.name }}</div>
                    </div>

                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Производственный №</div>
                      <div class="flex-1 param-table-value">{{ order.factoryOrderId }}</div>
                    </div>

                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Текущий статус</div>
                      <div class="flex-1 param-table-value">
                        {{ order.status.action | defaultCuttingOrderStatusName }}
                      </div>
                    </div>

                    <ng-template #orderPrice>
                      <ng-container *ngIf="order.vatPercent > 0; else withoutVATLabel">
                        <div class="flex flex-row justify-start items-center">
                          <div i18n class="flex-1 param-table-label text-right"
                            ><span *ngIf="order.vatIncludeInPrice; else simpleVAT"
                              >В т.ч. НДС ({{ order.vatPercent }}%)</span
                            >
                            <ng-template #simpleVAT>НДС ({{ order.vatPercent }}%)</ng-template></div
                          >
                          <div class="flex-1 param-table-value">
                            {{ order.amountVAT | formatNumber : 2 | formatCurrency }}
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #withoutVATLabel>
                        <div class="flex flex-row justify-start items-center">
                          <div i18n class="flex-1 param-table-label text-right"><span>Без налога (НДС) </span></div>
                          <div class="flex-1 param-table-value">—</div>
                        </div>
                      </ng-template>

                      <div class="flex flex-row justify-start items-center">
                        <div i18n class="flex-1 param-table-label text-right"><span>Всего к оплате</span></div>
                        <div class="flex-1 param-table-value">
                          {{ order.amount | formatNumber : 2 | formatCurrency }}
                        </div>
                      </div>
                    </ng-template>

                    <ng-container *ngIf="order.amountWithoutDiscount - order.amount > 0.001; else withoutDiscount">
                      <div class="flex flex-row justify-start items-center">
                        <div i18n class="flex-1 param-table-label text-right">Стоимость без скидки</div>
                        <div class="flex-1 param-table-value">
                          {{
                            order.amountWithoutDiscount -
                              (order.deliveryType === 1 ? (order.pointOfIssue ? order.pointOfIssue.price : 0) : 0)
                              | formatNumber : 2
                              | formatCurrency
                          }}
                        </div>
                      </div>

                      <div class="flex flex-row justify-start items-center">
                        <div i18n class="flex-1 param-table-label text-right">Скидка</div>
                        <div class="flex-1 param-table-value">
                          {{ order.amountWithoutDiscount - order.amountWithoutVAT | formatNumber : 2 | formatCurrency }}
                        </div>
                      </div>

                      <ng-container *ngTemplateOutlet="deliveryPriceInfo"></ng-container>

                      <div class="flex flex-row justify-start items-center">
                        <div i18n class="flex-1 param-table-label text-right">Итого</div>
                        <div class="flex-1 param-table-value">
                          {{ order.amountWithoutVAT | formatNumber : 2 | formatCurrency }}
                        </div>
                      </div>
                      <ng-containter *ngTemplateOutlet="orderPrice"></ng-containter>
                    </ng-container>

                    <ng-template #withoutDiscount>
                      <ng-container *ngTemplateOutlet="deliveryPriceInfo"></ng-container>

                      <div class="flex flex-row justify-start items-center">
                        <div i18n class="flex-1 param-table-label text-right">Стоимость заказа</div>
                        <div class="flex-1 param-table-value">
                          {{ order.amountWithoutDiscount | formatNumber : 2 | formatCurrency }}
                        </div>
                      </div>
                      <ng-containter *ngTemplateOutlet="orderPrice"></ng-containter>
                    </ng-template>

                    <ng-template #deliveryPriceInfo>
                      <div class="flex flex-row justify-start items-center" *ngIf="order.deliveryType !== 0">
                        <div i18n class="flex-1 param-table-label text-right">Стоимость доставки</div>
                        <div class="flex-1 param-table-value" *ngIf="order.deliveryType === 2" i18n
                          >Необходимо уточнить у менеджера</div
                        >
                        <div class="flex-1 param-table-value" *ngIf="order.deliveryType === 1">
                          {{ (order.pointOfIssue ? order.pointOfIssue.price : 0) | formatNumber : 2 | formatCurrency }}
                        </div>
                      </div>
                    </ng-template>

                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Сумма платежей</div>
                      <div class="flex-1 param-table-value">
                        {{ order.sumPayments | formatNumber : 2 | formatCurrency }}
                      </div>
                    </div>

                    <div *ngIf="order.discount.promoActive" class="message-box info">
                      <span i18n>Активирован промокод</span>.&nbsp;

                      <ng-container *ngIf="hasMaterialsDiscount || hasOperationsDiscount">
                        <span i18n>Скидки на материалы/операции</span>

                        <button
                          *ngIf="hasMaterialsDiscount"
                          mat-icon-button
                          i18n-aria-label
                          aria-label="Скидки на материалы"
                          i18n-matTooltip
                          matTooltip="Скидки на материалы"
                          (click)="openGroupMaterialDiscountTreeDialog()">
                          <mat-icon>layers</mat-icon>
                        </button>

                        <button
                          *ngIf="hasOperationsDiscount"
                          mat-icon-button
                          i18n-aria-label
                          aria-label="Скидки на операции"
                          i18n-matTooltip
                          matTooltip="Скидки на операции"
                          (click)="openGroupOperationDiscountTreeDialog()">
                          <mat-icon>engineering</mat-icon>
                        </button>
                      </ng-container>
                      &nbsp;
                      <span i18n *ngIf="order.discount.discount"
                        >Скидка на заказ – {{ order.discount.discount | formatNumber : 2 | formatCurrency }}</span
                      >
                    </div>

                    <div
                      class="flex flex-row justify-start items-center"
                      *ngIf="
                        order.status.action === thisOrderStatusActions.CuttingCompleted && !order.discount.promoActive
                      ">
                      <div i18n class="flex-1 param-table-label text-right mb-3">Промокод</div>
                      <div class="flex-1 param-table-value flex flex-row justify-start items-center">
                        <mat-form-field appearance="outline" class="dense-input">
                          <input i18n-placeholder matInput placeholder="Код" type="text" [formControl]="promoCode" />
                          <mat-error i18n *ngIf="promoCode.hasError('required')">Поле не должно быть пустым</mat-error>
                          <mat-error i18n *ngIf="!promoCode.hasError('required') && promoCode.hasError('minlength')"
                            >Минимальная длина - {{ promoCode.errors['minlength'].requiredLength }}</mat-error
                          >
                          <mat-error i18n *ngIf="promoCode.hasError('maxlength')"
                            >Максимальная длина - {{ promoCode.errors['maxlength'].requiredLength }}</mat-error
                          >
                          <button
                            matSuffix
                            mat-icon-button
                            i18n-matTooltip
                            matTooltip="Активировать"
                            [disabled]="promoCode.invalid"
                            (click)="activatePromoCode()">
                            <mat-icon>flash_on</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-col justify-start items-stretch w-1/5">
                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Дата создания</div>
                      <div class="flex-1 param-table-value">
                        {{ order.dateCreate | date : 'shortDate' }}
                      </div>
                    </div>

                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Дата оформления</div>
                      <div class="flex-1 param-table-value">
                        {{ order.dateOrdering | date : 'shortDate' }}
                      </div>
                    </div>

                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Дата принятия</div>
                      <div class="flex-1 param-table-value">
                        {{ order.dateConfirm | date : 'shortDate' }}
                      </div>
                    </div>

                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Дата оплаты</div>
                      <div class="flex-1 param-table-value">
                        {{ order.datePayming | date : 'shortDate' }}
                      </div>
                    </div>

                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Планируемая дата выдачи</div>
                      <div class="flex-1 param-table-value">
                        {{ order.plannedDateOfIssue | date : 'shortDate' }}
                      </div>
                    </div>

                    <div class="flex flex-row justify-start items-center">
                      <div i18n class="flex-1 param-table-label text-right">Дата выдачи</div>
                      <div class="flex-1 param-table-value">
                        {{ order.dateOfIssue | date : 'shortDate' }}
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-col justify-start items-stretch w-1/5">
                    <div class="flex flex-row justify-start items-center" *ngIf="order.managerName">
                      <div i18n class="flex-1 param-table-label text-right">Менеджер</div>
                      <div class="flex-1 param-table-value">
                        {{ order.managerName }}
                        <ng-container *ngIf="order.managerPhone">
                          ,&nbsp;<a href="tel:+{{ order.managerPhone }}">{{ order.managerPhone }}</a>
                        </ng-container>
                      </div>
                    </div>

                    <div
                      class="flex flex-row justify-start items-center"
                      *ngIf="
                        editableOrder && (cuttingSettings?.delivery?.courier || cuttingSettings?.delivery?.pointOfIssue)
                      ">
                      <div i18n class="flex-1 param-table-label text-right">Доставка</div>
                      <div class="flex-1 param-table-value">
                        <mat-radio-group
                          [(ngModel)]="order.deliveryType"
                          class="flex flex-col justify-start items-start"
                          (ngModelChange)="
                            orderId !== 'new' ? saveDeliveryType($event) : null;
                            $event === 1 && !order.pointOfIssue ? openPointsOfIssueDialog() : null
                          ">
                          <mat-radio-button
                            [ngClass]="{ hidden: !cuttingSettings.delivery.pointOfIssue }"
                            [value]="1"
                            i18n
                            >Самовывоз</mat-radio-button
                          >
                          <mat-radio-button [ngClass]="{ hidden: !cuttingSettings.delivery.courier }" [value]="2" i18n
                            >Курьер</mat-radio-button
                          >
                        </mat-radio-group>
                      </div>
                    </div>

                    <div class="flex flex-row justify-start items-center" *ngIf="editableOrder">
                      <div i18n class="flex-1 param-table-label text-right">Вес</div>
                      <div class="flex-1 param-table-value" i18n>{{ order.weight }} кг</div>
                    </div>
                  </div>
                </div>

                <!-- DELIVERY -->
                <div class="flex flex-row justify-start items-center" *ngIf="order.deliveryType !== 0">
                  <div i18n class="param-table-label text-right">Адрес доставки</div>
                  <div class="w-1/2 param-table-value">
                    <ng-container *ngIf="order.deliveryType === 2">
                      <!-- <mat-form-field *ngIf="editableOrder" class="w-full">
                                            <input type="text"
                                                [value]="order.deliveryAddress ? order.deliveryAddress.value : ''"
                                                (blur)="blurDeliveryAddress($event)" matInput #deliveryAddress>
                                        </mat-form-field> -->

                      <mat-form-field *ngIf="editableOrder" class="w-full no-label">
                        <input
                          (blur)="handleDeliveryAddressInput()"
                          type="text"
                          matInput
                          [formControl]="deliveryAddressControl"
                          [matAutocomplete]="auto"
                          required />
                        <mat-autocomplete
                          autoActiveFirstOption
                          #auto="matAutocomplete"
                          [displayWith]="addressAutocompleteDisplayFn">
                          <mat-option
                            *ngFor="let option of addressResponse$ | async"
                            (onSelectionChange)="updateSelectedAddress(option)"
                            [value]="option">
                            {{ addressAutocompleteDisplayFn(option) }}
                          </mat-option>
                        </mat-autocomplete>

                        <mat-error i18n *ngIf="deliveryAddressControl.hasError('required')"
                          >Поле не должно быть пустым</mat-error
                        >

                        <mat-error *ngIf="deliveryAddressControl.hasError('noObject')" i18n
                          >Выберите адрес из списка</mat-error
                        >
                      </mat-form-field>

                      <div *ngIf="!editableOrder">
                        <span *ngIf="order.deliveryAddress">{{ order.deliveryAddress.value }}</span>
                        <span *ngIf="!order.deliveryAddress" i18n>Не задан</span>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="order.deliveryType === 1">
                      <div class="param-table-value flex flex-row justify-start items-center">
                        <div *ngIf="order.pointOfIssue">
                          {{ order.pointOfIssue.name }}.
                          {{ order.pointOfIssue.address.value }}
                          <span *ngIf="order.pointOfIssue.note">. {{ order.pointOfIssue.note }}</span>
                        </div>

                        <button mat-icon-button class="ml-4" *ngIf="editableOrder" (click)="openPointsOfIssueDialog()">
                          <mat-icon>{{ order.pointOfIssue ? 'edit' : 'add_circle_outline' }} </mat-icon>
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <!-- /DELIVERY -->

                <!-- CUTTING ENGINE -->
                <ng-container *ngIf="settingsSyncDate$ | async as settingsSyncDate">
                  <div
                    class="flex flex-row justify-start items-center gap-2"
                    *ngIf="
                      settingsSyncDate.result &&
                      settingsSyncDate.result.newCuttingSetting &&
                      cuttingSettings.enabledForClientCuttingEngines.length > 1 &&
                      order.cuttingEngine !== 3
                    ">
                    <div i18n class="param-table-label text-right">Движок раскроя</div>
                    <div class="flex-1 param-table-value">
                      <mat-form-field appearance="outline" class="dense-input">
                        <mat-select
                          #engineSelect
                          [value]="order.cuttingEngine"
                          (selectionChange)="changeOrderEngine($event.value)"
                          name="item">
                          <mat-option
                            *ngFor="let engine of cuttingSettings.enabledForClientCuttingEngines"
                            [value]="engine">
                            <ng-container [ngSwitch]="engine">
                              <span *ngSwitchCase="0">
                                {{ userLang === 'ru' ? 'БАЗИС-Раскрой 11' : 'BAZIS-Cutting 11' }}
                              </span>
                              <span *ngSwitchCase="1">
                                {{ userLang === 'ru' ? 'БАЗИС-Раскрой 2023' : 'BAZIS-Cutting 2023' }}
                              </span>
                              <span *ngSwitchCase="2">
                                {{ userLang === 'ru' ? 'БАЗИС-Раскрой 2023 Плотный' : 'BAZIS-Cutting 2023 Tight' }}
                              </span>
                              <span *ngSwitchDefault> ENGINE {{ engine }} </span>
                            </ng-container>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </ng-container>
                <!-- /CUTTING ENGINE -->

                <div>
                  <div *ngIf="order.note" class="flex flex-row justify-start items-start">
                    <div class="param-table-label text-right" i18n>Примечание</div>
                    <div class="param-table-value">{{ order.note }}</div>
                  </div>
                  <div class="mt-3">
                    <button mat-stroked-button color="primary" *ngIf="editableOrder" (click)="openNodeEditDialog()">
                      <span i18n *ngIf="order.note">Редактировать примечание</span>
                      <span i18n *ngIf="!order.note">Добавить примечание к заказу</span>
                    </button>
                  </div>
                </div>

                <div>
                  <div *ngIf="order.clientNote" class="flex flex-row justify-start items-start">
                    <div class="param-table-label text-right" i18n>Внутренний комментарий</div>
                    <div class="param-table-value">{{ order.clientNote }}</div>
                  </div>
                  <div class="mt-3">
                    <button
                      i18n-matTooltip
                      matTooltip="Комментарий виден только Вам. Менеджер его не видит."
                      mat-stroked-button
                      color="primary"
                      *ngIf="editableOrder"
                      (click)="openClientNodeEditDialog()">
                      <span i18n *ngIf="order.clientNote">Редактировать внутренний комментарий</span>
                      <span i18n *ngIf="!order.clientNote">Добавить внутренний комментарий</span>
                    </button>
                  </div>
                </div>
              </div>
            </mat-tab>

            <mat-tab
              i18n-label
              label="Список панелей"
              #materialsTab
              *ngIf="presetSettings.componentsAvailability.orderDetail.panelList">
              <div class="tab-content" fusePerfectScrollbar>
                <cutting-materials
                  *ngIf="order"
                  (valid)="materialsValid = $event"
                  #materials
                  [editableOrder]="editableOrder"
                  [orderId]="order.id"
                  [cuttingSettings]="cuttingSettings"
                  [clientOptions]="clientOptions">
                </cutting-materials>
              </div>
            </mat-tab>

            <mat-tab
              i18n-label
              label="Фасады"
              #materialsTab
              *ngIf="presetSettings.componentsAvailability.facades.enabled">
              <div class="tab-content flex flex-col" fusePerfectScrollbar>
                <cutting-facades
                  class="flex flex-col flex-auto"
                  fusePerfectScrollbar
                  *ngIf="order"
                  #facades
                  [disabled]="!editableOrder"
                  [orderId]="+orderId"
                  [componentsAvailability]="presetSettings.componentsAvailability.facades"
                  [cuttingSettings]="cuttingSettings">
                </cutting-facades>
              </div>
            </mat-tab>

            <mat-tab i18n-label label="Товары" #modelsTab>
              <div class="tab-content" fusePerfectScrollbar>
                <div class="flex flex-row justify-start items-center gap-4 p-4">
                  <ng-container
                    *ngIf="
                      presetSettings.componentsAvailability.orderDetail.products &&
                      hasProductsTariffOptions(tariffOptions.result)
                    ">
                    <div>
                      <button [disabled]="!editableOrder" (click)="openAddElasticModelDialog()" mat-stroked-button i18n
                        >Добавить изделие</button
                      >
                    </div>

                    <mat-divider vertical class="h-8"> </mat-divider>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      hasImportOrBazisReading(tariffOptions.result) &&
                      (presetSettings.componentsAvailability.orderDetail.models ||
                        presetSettings.componentsAvailability.orderDetail.bCADModels)
                    ">
                    <div>
                      <input
                        multiple
                        hidden
                        type="file"
                        #importModelInput
                        accept="{{ allowedImportModelExt.join(', ') }}"
                        (change)="onChangeModelsFileInput($any($event))" />
                      <input
                        multiple
                        hidden
                        type="file"
                        #modelFileInput
                        accept="{{ allowedModelExt.join(', ') }}"
                        (change)="onChangeModelsFileInput($any($event))" />

                      <div class="flex flex-row justify-start items-center gap-4">
                        <button
                          i18n
                          [disabled]="!editableOrder"
                          mat-stroked-button
                          (click)="modelFileInput.click()"
                          *ngIf="
                            hasBazisReading(tariffOptions.result) &&
                            presetSettings.componentsAvailability.orderDetail.models
                          "
                          >Загрузить БАЗИС-модель</button
                        >

                        <button
                          i18n
                          [disabled]="!editableOrder"
                          *ngIf="
                            hasImport(tariffOptions.result) &&
                            presetSettings.componentsAvailability.orderDetail.bCADModels
                          "
                          (click)="importModelInput.click()"
                          mat-stroked-button
                          >Импорт проекта (bCAD, K3)</button
                        >

                        <ng-container *ngIf="availableModelHoleDiameters$ | async as data">
                          <mat-icon
                            *ngIf="
                              data.result &&
                              (data.result.through.length > 0 ||
                                data.result.blind.length > 0 ||
                                data.result.edge.length > 0)
                            "
                            class="amber-fg"
                            i18n-matTooltip
                            matTooltipClass="available-cad-models-holes-diameters-tooltip"
                            matTooltip="Доступные диаметры отверстий:
    сквозные: {{ holeDiamsList2String(data.result.through) }}
    глухие: {{ holeDiamsList2String(data.result.blind) }}
    торцевые: {{ holeDiamsList2String(data.result.edge) }}">
                            warning
                          </mat-icon>
                        </ng-container>
                      </div>
                    </div>

                    <mat-divider vertical class="h-8"> </mat-divider>
                  </ng-container>

                  <div *ngIf="presetSettings.componentsAvailability.orderDetail.furniture">
                    <div class="flex flex-row justify-start items-center gap-4">
                      <button [disabled]="!editableOrder" (click)="addFurniture()" mat-stroked-button i18n
                        >Добавить фурнитуру</button
                      >
                    </div>
                  </div>
                </div>

                <mat-divider> </mat-divider>

                <ng-container
                  *ngIf="
                    presetSettings.componentsAvailability.orderDetail.products &&
                    hasProductsTariffOptions(tariffOptions.result)
                  ">
                  <div class="mat-title m-4" i18n>Изделия</div>

                  <mat-divider> </mat-divider>

                  <cutting-products-list
                    *ngIf="orderId === 'new' || order?.id"
                    [hubConnection]="hubConnection"
                    #orderProductList
                    (needSaveOrder)="addOrderForChildren()"
                    [editableOrder]="(editableOrder && hubConnected) || orderId === 'new'">
                  </cutting-products-list>
                </ng-container>

                <ng-container
                  *ngIf="
                    hasImportOrBazisReading(tariffOptions.result) &&
                    (presetSettings.componentsAvailability.orderDetail.models ||
                      presetSettings.componentsAvailability.orderDetail.bCADModels)
                  ">
                  <div class="mat-title m-4" i18n>Модели</div>

                  <mat-divider> </mat-divider>

                  <csl-order-models
                    #orderFiles
                    [showModelWriteSettings]="showModelWriteSettings"
                    [disableDownloadingModelForClient]="cuttingSettings.disableDownloadingModelForClient"
                    [orderStatusAction]="order.status.action"
                    (materialsLinked)="onModelMaterialsLinked($event)"
                    (modelDeleted)="onModelDeleted($event)"
                    (needSaveOrder)="addOrderForChildren()"
                    [editableOrder]="(editableOrder && hubConnected) || orderId === 'new'"
                    [cuttingSettings]="cuttingSettings"
                    [orderId]="+orderId">
                  </csl-order-models>
                </ng-container>

                <ng-container *ngIf="presetSettings.componentsAvailability.orderDetail.furniture">
                  <div class="mat-title m-4" i18n>Фурнитура</div>

                  <mat-divider> </mat-divider>

                  <cutting-furniture-list
                    #orderFurniture
                    (needSaveOrder)="addOrderForChildren()"
                    [editableOrder]="editableOrder">
                  </cutting-furniture-list>
                </ng-container>
              </div>
            </mat-tab>

            <mat-tab i18n-label label="Столешницы" *ngIf="presetSettings.componentsAvailability.countertops.enabled">
              <div class="tab-content" fusePerfectScrollbar>
                <cutting-countertops
                  #countertops
                  *ngIf="order"
                  [disabled]="!editableOrder"
                  [componentsAvailability]="presetSettings.componentsAvailability.countertops"
                  [outlineOptions]="cuttingSettings.outlineEditorOptions"
                  [orderId]="+orderId"></cutting-countertops>
              </div>
            </mat-tab>

            <mat-tab
              i18n-label
              label="Пользовательские материалы"
              *ngIf="presetSettings.componentsAvailability.orderDetail.clientMaterials">
              <div class="tab-content" fusePerfectScrollbar>
                <cutting-client-materials [disabled]="!editableOrder"></cutting-client-materials>
              </div>
            </mat-tab>

            <mat-tab i18n-label label="Результат раскроя" #cuttingResultTab>
              <div class="tab-content" fusePerfectScrollbar>
                <cutting-cutting-result
                  #cuttingResult
                  [achivedOrder]="order.archived"
                  [showSubTabs]="cuttingResultTab.isActive"
                  [clientOptions]="clientOptions"
                  [cuttingSettings]="cuttingSettings">
                </cutting-cutting-result>
              </div>
            </mat-tab>

            <mat-tab i18n-label label="Смета по заказу" #orderEstimateTab>
              <div class="tab-content" fusePerfectScrollbar>
                <cutting-estimate
                  [cuttingSettings]="cuttingSettings"
                  [materialDiscount]="order.discount.materialDiscount"
                  [operationsDiscount]="order.discount.operationDiscount">
                </cutting-estimate>
              </div>
            </mat-tab>

            <mat-tab
              i18n-label
              label="Документы"
              *ngIf="
                order.status.action === thisOrderStatusActions.Verified ||
                order.status.action === thisOrderStatusActions.Confirm ||
                order.status.action === thisOrderStatusActions.Completed ||
                order.status.action === thisOrderStatusActions.Paid
              ">
              <div class="tab-content" fusePerfectScrollbar>
                <cutting-order-documents #orderDocuments [editableOrder]="editableOrder"> </cutting-order-documents>
              </div>
            </mat-tab>

            <mat-tab #cutHistoryTab>
              <ng-template mat-tab-label>
                <div
                  [matBadge]="noCheckedCutErrors"
                  matBadgeSize="small"
                  [matBadgeHidden]="noCheckedCutErrors <= 0"
                  matBadgeOverlap="false"
                  matBadgeColor="warn"
                  i18n
                  >История раскроя</div
                >
              </ng-template>
              <div class="tab-content" fusePerfectScrollbar>
                <cutting-cut-history
                  (materialChanged)="copyMaterialsChange($event)"
                  [materials]="materialsComponent?.materials"></cutting-cut-history>
              </div>
            </mat-tab>

            <mat-tab #questionTab *ngIf="isShowQuestionList">
              <ng-template mat-tab-label>
                <span
                  [matBadge]="unreadedCount"
                  matBadgeSize="small"
                  matBadgeOverlap="false"
                  matBadgeColor="warn"
                  [matBadgeHidden]="unreadedCount === 0"
                  >{{ questionTabName }}</span
                >
              </ng-template>
              <ng-template matTabContent>
                <cutting-order-question-chat [orderId]="+orderId" [question]="question"></cutting-order-question-chat>
              </ng-template>
            </mat-tab>
          </mat-tab-group>

          <div *ngIf="!tariffOptions.result && !tariffOptions.error" class="p-6">Loading…</div>
        </ng-container>
      </div>
      <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
